module.exports = function getResource(label, vars = []) {
    const resources = {
        placeOrder: 'Place Order',
        placeKlarnaOrder: 'Continue to Klarna',
        orderTotal: 'Order total',
        item: 'item',
        items: 'items',
        authorizeErrorMessage: 'Trouble connecting to Klarna. Please use a different payment method or try again later.',
        denialMessage: 'We’re sorry! Klarna payment could not be authorized. Please select a different payment method.'
    };

    return resources[label];
};
